
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/companies",
      function () {
        return require("private-next-pages/admin/companies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/companies"])
      });
    }
  